<pt-workflow-update-button
  *ngrxLet="nextStatus$ as nextStatus"
  [color]="color"
  [type]="type"
  [currentState]="currentStatus$ | async | titlecase"
  [nextState]="nextStatus | titlecase"
  (buttonClick)="updateStatus(nextStatus)"
>
  <button
    *ngFor="let status of statuses; trackBy: trackByStatus"
    mat-menu-item
    [disabled]="status | map: isCurrentStatus$:this | async"
    (click)="updateStatus(status)"
  >
    {{ status | titlecase }}
  </button>
</pt-workflow-update-button>
